var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScaleFrontend = function SvgScaleFrontend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 111,
    fill: "none",
    viewBox: "0 0 110 111"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#scale-frontend_svg__paint0_linear_12030_11691)",
    d: "M40.692 53.382a16.96 16.96 0 0 1 8.921-4.888 16.93 16.93 0 0 1 10.105 1.102 17 17 0 0 1 7.667 6.695 17.07 17.07 0 0 1 2.48 9.889h8.287l-.058-.04q.052-1.367-.051-2.73l4.339-2.987-1.952-6.811-5.245-.213a20 20 0 0 0-1.418-2.372l2.296-4.744-5.114-4.923-4.654 2.441c-.064-.04-1.66-.967-2.4-1.324l-.401-5.25L56.64 35.5l-2.8 4.45a24 24 0 0 0-2.71.052l-3.001-4.364-6.784 1.951-.218 5.28q-1.207.635-2.336 1.405l-4.746-2.275-4.655 4.86 2.17 4.933q-.723 1.17-1.314 2.413l-5.252.386-1.722 6.908 4.454 2.839v1.882h8.213a17 17 0 0 1 1.025-6.922 16.95 16.95 0 0 1 3.727-5.916",
    opacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M18.566 69.26H76.75a.625.625 0 0 1 .566.625.63.63 0 0 1-.566.624H18.566a.625.625 0 0 1-.566-.624.63.63 0 0 1 .566-.625m64.33 0h9.424a.625.625 0 0 1 .566.625.63.63 0 0 1-.566.624h-9.423a.625.625 0 0 1-.566-.624.63.63 0 0 1 .566-.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M79.825 66.18c.73.002 1.444.221 2.05.63a3.718 3.718 0 0 1 .548 5.703 3.69 3.69 0 0 1-4.027.799 3.7 3.7 0 0 1-1.657-1.366 3.72 3.72 0 0 1-.34-3.481 3.7 3.7 0 0 1 2.007-2.008 3.7 3.7 0 0 1 1.419-.277m0 6.166a2.45 2.45 0 0 0 2.27-1.523 2.47 2.47 0 0 0-.535-2.686 2.453 2.453 0 0 0-4.192 1.75c.002.653.261 1.278.722 1.74.46.46 1.084.719 1.735.719"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M18.566 80.567h44.45a.625.625 0 0 1 .566.625.63.63 0 0 1-.566.624h-44.45a.625.625 0 0 1-.566-.624.63.63 0 0 1 .566-.625m50.597 0H92.32a.625.625 0 0 1 .566.625.63.63 0 0 1-.566.624H69.163a.625.625 0 0 1-.566-.624.63.63 0 0 1 .566-.625",
    className: "scale-frontend_svg__orange-line"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M18.566 91.869h21.637a.625.625 0 0 1 .565.624.63.63 0 0 1-.566.625H18.567a.625.625 0 0 1-.566-.625.63.63 0 0 1 .566-.624m27.783 0H92.32a.625.625 0 0 1 .566.624.63.63 0 0 1-.566.625H46.35a.62.62 0 0 1-.633-.37.63.63 0 0 1 .632-.88M18.566 103.176H59.75a.623.623 0 0 1 .566.625.625.625 0 0 1-.566.624H18.566a.623.623 0 0 1-.566-.624.626.626 0 0 1 .566-.625m47.337 0h26.4a.623.623 0 0 1 .566.625.625.625 0 0 1-.566.624h-26.4a.623.623 0 0 1-.566-.624.626.626 0 0 1 .566-.625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M62.829 100.084c.73 0 1.444.217 2.052.624a3.71 3.71 0 0 1 1.574 3.803 3.705 3.705 0 0 1-2.898 2.916 3.695 3.695 0 0 1-4.424-3.624c0-.984.389-1.928 1.082-2.625a3.7 3.7 0 0 1 2.614-1.094m0 6.166a2.453 2.453 0 0 0 2.261-1.524 2.47 2.47 0 0 0-.54-2.679 2.444 2.444 0 0 0-3.77.388 2.465 2.465 0 0 0 .316 3.101c.46.459 1.084.716 1.733.714",
    className: "scale-frontend_svg__orange-figure"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#scale-frontend_svg__paint1_linear_12030_11691)",
    d: "M42.809 96.152a3.65 3.65 0 0 0 3.644-3.656 3.65 3.65 0 0 0-3.645-3.656 3.65 3.65 0 0 0-3.644 3.656 3.65 3.65 0 0 0 3.645 3.656"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#scale-frontend_svg__paint2_linear_12030_11691)",
    d: "M66.527 84.229a3.65 3.65 0 0 0 3.645-3.656 3.65 3.65 0 0 0-3.645-3.656 3.65 3.65 0 0 0-3.644 3.656 3.65 3.65 0 0 0 3.644 3.656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-frontend_svg__paint0_linear_12030_11691",
    x1: 23.285,
    x2: 82.382,
    y1: 50.837,
    y2: 50.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "scale-frontend_svg__orange-gradient",
    stopColor: "#2C3144",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    className: "scale-frontend_svg__orange-gradient",
    offset: 1,
    stopColor: "#2C3144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-frontend_svg__paint1_linear_12030_11691",
    x1: 39.158,
    x2: 46.453,
    y1: 92.496,
    y2: 92.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-frontend_svg__paint2_linear_12030_11691",
    x1: 62.877,
    x2: 70.172,
    y1: 80.573,
    y2: 80.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144"
  })))));
};
export default SvgScaleFrontend;